module.exports = __webpack_public_path__ + "img/brand_bialetti.c09bd8eb.webp";